var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"justify-end"},[_c('v-col',{attrs:{"cols":"12","sm":"4","md":"3","xl":"2"}},[_c('default-button',{attrs:{"disabled":""}},[_vm._v("Criar Perfil")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }